<template>
  <span>{{ responsibleName }}</span>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    responsibleName() {
      const responsible = this.item && this.item.responsiblePerson;
      if (!responsible) return "-";
      return responsible.name || "-";
    },
  },
};
</script>
